import IOnGetPackingListDTO from "../models/DTO/IOnGetPackingListDTO";
import IOrder_ItemUI from "../models/IOrder_ItemUI";
import ICatalog_Item from "../models/ICatalog_Item";
import IQtyAssigned from "../models/IQtyAssigned";
import IPacking_List from "../models/IPacking_List";
import {sortBy} from "lodash-es";

const processPackingList = (data: IOnGetPackingListDTO, qtyAssigned: IQtyAssigned): {orderItemsSorted: IOrder_ItemUI[], qtyAssigned: IQtyAssigned, packingList: IPacking_List, catalogItems: ICatalog_Item[]} => {
    const _qtyAssigned = {
        ...qtyAssigned
    };



    const orderItemsFiltered = (data.packingList.Order_Items || []).filter((orderItem) => {
        if (data.packingList && data.packingList.Packing_List_Catalog_Item_Maps) {
            const catItemMaps = data.packingList.Packing_List_Catalog_Item_Maps;

            let found = false;

            for (const catItem of catItemMaps) {
                if (catItem.order_item_id === orderItem.id) {
                    found = true;
                }
            }

            const Product_Sources = orderItem.Catalog_Item?.Product_Sources;

            if (Product_Sources) {
                const pickedProductSources: ICatalog_Item[] = [];

                for (const productSource of Product_Sources) {
                    let productSourceFound = false;

                    for (const catItem of catItemMaps) {
                        if (catItem.catalog_item_id === productSource.id) {
                            productSourceFound = true;
                        }
                    }

                    if (productSourceFound) {
                        pickedProductSources.push(productSource);
                    }
                }

                orderItem.Catalog_Item!.Product_Sources = pickedProductSources;
            }

            // console.log("Found Item: ", found);

            return found;
        }
    });

    // const _selectedLots = {
    //     ...selectedLots
    // };

    if (data.packingList.Order_Items) {
        for (const orderItem of data.packingList.Order_Items) {
            // if (!_selectedLots[orderItem.guid]) {
            //     _selectedLots[orderItem.guid] = null;
            // }

            const packingListOrderItemMap = orderItem!.Packing_List_Order_Item_Map;

            const sources: any = {};

            if (orderItem.Catalog_Item?.has_alternate_sourcing) {
                const catItemMapId = orderItem?.Packing_List_Order_Item_Map?.packing_list_cat_item_map_id;

                if (data.packingList.Packing_List_Catalog_Item_Maps) {
                    for (const itemMap of data.packingList.Packing_List_Catalog_Item_Maps) {
                        if (itemMap.id === catItemMapId) {
                            // sources[itemMap.Catalog_Item!.guid] = {
                            //     value: itemMap.qty_packed,
                            //     parent_catalog_item_id: itemMap.parent_catalog_item_id,
                            //     order_id: itemMap.order_id,
                            //     order_item_id: itemMap.order_item_id
                            // }
                        }

                        if (itemMap.order_item_id === orderItem.id && itemMap.parent_catalog_item_id) {
                            let qty_picked = 0;

                            if (data.packingList.Pick_List && data.packingList.Pick_List.Pick_List_Catalog_Item_Maps) {
                                for (const pickCatItem of data.packingList.Pick_List.Pick_List_Catalog_Item_Maps) {
                                    if (
                                        pickCatItem.catalog_item_id === itemMap.catalog_item_id &&
                                        pickCatItem.parent_catalog_item_id === itemMap.parent_catalog_item_id
                                    ) {
                                        qty_picked = pickCatItem.qty_picked;
                                    }
                                }
                            }

                            sources[itemMap.Catalog_Item!.guid] = {
                                qty_picked,
                                value: itemMap.qty_packed || qty_picked,
                                parent_catalog_item_id: itemMap.parent_catalog_item_id,
                                order_id: itemMap.order_id,
                                order_item_id: itemMap.order_item_id,
                            };
                        }
                    }
                }

                // if (data.packingList.Catalog_Items) {
                //     for (const catalogItem of data.packingList.Catalog_Items) {
                //         if (catalogItem.Packing_List_Catalog_Item_Map?.id === catItemMapId &&
                //             catalogItem.Packing_List_Catalog_Item_Map.parent_catalog_item_id) {
                //             sources[catalogItem.guid] = {
                //                 value: catalogItem.Packing_List_Catalog_Item_Map.qty_packed,
                //                 parent_catalog_item_id: catalogItem.Packing_List_Catalog_Item_Map.parent_catalog_item_id,
                //                 order_item_id: orderItem.id
                //             };
                //         }
                //     }
                // }
            }

            let qty_picked = 0;

            if (data.packingList.Pick_List && data.packingList.Pick_List.Pick_List_Catalog_Item_Maps) {
                for (const catItemMap of data.packingList.Pick_List.Pick_List_Catalog_Item_Maps) {
                    if (catItemMap.catalog_item_id === orderItem.catalog_item_id) {
                        qty_picked = catItemMap.qty_picked;
                    }
                }
            }

            _qtyAssigned[orderItem.guid] = {
                qty_picked,
                value: packingListOrderItemMap?.qty_assigned || 0,
                sources,
            };
        }
    }

    // console.log("orderItemsFiltered", orderItemsFiltered);

    const orderItems = orderItemsFiltered as IOrder_ItemUI[];

    for (const orderItem of orderItems) {
        if (orderItem.use_lots) {
            _qtyAssigned[orderItem.guid].value = 0;
        }
    }

    // This function needs to be unit tested. It feels 'dangerous'
    if (data.packingList.Order_Item_Lot_Maps && data.packingList.Order_Item_Lot_Maps.length) {
        for (const itemLotMap of data.packingList.Order_Item_Lot_Maps) {
            for (const orderItem of orderItems) {
                if (orderItem.id === itemLotMap.order_item_id) {
                    if (!orderItem.Lots) {
                        orderItem.Lots = [];
                    }

                    if (itemLotMap.Lot) {
                        orderItem.Lots.push(itemLotMap.Lot);
                        _qtyAssigned[orderItem.guid].value += itemLotMap.qty || 0;
                    }
                }
            }
        }
    }

    const orderItemsSorted = sortBy(
        orderItems,
        (item) => {
            return item.Catalog_Item?.sku;
        },
        ["asc"]
    );

    return {orderItemsSorted, qtyAssigned: _qtyAssigned, packingList: data.packingList, catalogItems: data.packingList.Catalog_Items || []};
}

export const PackingListService = {
    processPackingList
}
